import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
//import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { DeleteConfirmDialogComponent } from '../../common-dialogs/delete-confirm-dialog/delete-confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'intelli-edit-menu',
  templateUrl: './intelli-edit-menu.component.html',
  styleUrls: ['./intelli-edit-menu.component.css']
})
export class IntelliEditMenuComponent implements OnInit {

  constructor( public dialog: MatDialog) { }

  @Output() changeEditState: EventEmitter<void> = new EventEmitter();
  @Output() change: EventEmitter<string> = new EventEmitter();
  @Input() editState: boolean = false;
  
  ngOnInit() {
  }

  public onChangeEditState() {
    this.change.emit("editState");
  }

  public onBackToList() {
    console.log("onBackToList")
    this.change.emit("backToList");
  }

  public onBack() {
    console.log("onBack")
    this.change.emit("back");
  }

  public onRemove() {
  


    const dialogRef = this.dialog.open(DeleteConfirmDialogComponent, {
      width: '500px',
      data: { question: 'Realmente deseja excluir esse produto?' }
    });

    dialogRef.afterClosed().subscribe(result => {
  

      if (result == "ok") {

        console.log("onRemove")
      this.change.emit("remove");

      }
    });



   
  }
}
